export type ShowcaseFinish = 'champagne' | 'carbon' | 'mirror'

export interface FinishInfo {
    key: ShowcaseFinish
    number: string
    name: string
    copy: string
    detail: string
    swatch: string
    model: string
    image: string
    imageAlt: string
}

export const FINISHES: FinishInfo[] = [
    {
        key: 'champagne',
        number: '01',
        name: 'Brushed Champagne Gold',
        copy: 'Hand-brushed spokes in a warm champagne tone, framed by bright diamond-cut faces.',
        detail: 'Satin grain follows every spoke from hub to lip, so the colour shifts as the wheel turns.',
        swatch: 'linear-gradient(115deg, #7d6435 0%, #d9bb7c 28%, #f6e7c1 42%, #c9a868 58%, #8a6f3e 78%, #e3c88f 100%)',
        model: 'Executive',
        image: '/images/wheel-executive-gold.jpg',
        imageAlt: 'Forged monoblock executive wheel in brushed champagne gold with diamond-cut spokes, lit in a dark studio'
    },
    {
        key: 'carbon',
        number: '02',
        name: 'Dark Satin Carbon',
        copy: 'Deep satin graphite under a protective clear coat, with machined faces that catch the light.',
        detail: 'A low-sheen finish that reads almost black in shadow and reveals its depth in the sun.',
        swatch: 'linear-gradient(115deg, #0d0f12 0%, #2a2f37 30%, #4b525d 45%, #1b1f25 60%, #0f1115 80%, #343a44 100%)',
        model: 'Deep Concave',
        image: '/images/wheel-deep-concave.jpg',
        imageAlt: 'Deep concave 10-spoke forged wheel in dark satin carbon with bright machined spoke edges and gold reflections'
    },
    {
        key: 'mirror',
        number: '03',
        name: 'Raw Polished Mirror Lip',
        copy: 'Polished by hand to a true mirror, so the lip reflects every light it passes.',
        detail: 'Raw machined spokes meet a lip taken through successive polishing stages to a flawless shine.',
        swatch: 'linear-gradient(115deg, #8e969f 0%, #f4f6f8 25%, #ffffff 38%, #b7bec7 52%, #6f7780 70%, #e9edf1 100%)',
        model: 'Lightweight Track',
        image: '/images/wheel-track-lightweight.jpg',
        imageAlt: 'Lightweight forged track wheel with raw machined split spokes and a polished mirror lip in a dark studio'
    }
]
